import { m } from "framer-motion";

export const mentalplus = {
  mentalplus_tab_help: 'Ma bouée',
  mentalplus_tab_videos: 'Vidéos',
  mentalplus_tab_home: 'Mon monde',
  mentalplus_tab_evolution: 'Évolution',
  mentalplus_tab_account: 'Compte',
  mentalplus_tab_questionnaires: 'Questionnaires',
  mentalplus_account_page_title: 'Compte et paramètres',
  mentalplus_account_manage: 'Gérer mon compte',
  mentalplus_account_deactivate: 'Désactiver mon compte',
  mentalplus_account_deactivate_message: 'Voulez-vous désactiver votre compte ?',
  mentalplus_account_notifications: 'Gérer mes notifications',
  mentalplus_account_notification_email: 'Notifications par email',
  mentalplus_account_notification_sms: 'Notifications par SMS',
  mentalplus_account_notification_push: 'Notifications push',
  mentalplus_account_notification_add_contact: 'Ajoutez un contact pour activer cette notification',
  mentalplus_account_notification_push_hint: 'Activez pour recevoir des notifications sur cet appareil',
  mentalplus_account_notification_push_permission_required: 'Autorisation refusée. Activez les notifications dans les réglages du navigateur ou de l\'appareil.',
  mentalplus_unsubscribe_title: 'Préférences de notification',
  mentalplus_unsubscribe_intro: 'Gérez les notifications que vous recevez de la part de cette étude.',
  mentalplus_unsubscribe_save: 'Enregistrer',
  mentalplus_unsubscribe_saved: 'Vos préférences ont été enregistrées.',
  mentalplus_unsubscribe_error: 'Une erreur est survenue. Veuillez réessayer.',
  mentalplus_unsubscribe_invalid: 'Ce lien de désinscription n\'est plus valide.',
  mentalplus_unsubscribe_push_note: 'Pour activer les notifications push, ouvrez l\'application.',
  mentalplus_unsubscribe_loading: 'Chargement de vos préférences…',
  mentalplus_account_tutorials: 'Voir les tutoriels',
  mentalplus_account_language: 'Modifier la langue',
  mentalplus_account_about: 'À propos',
  mentalplus_account_contact: 'Nous contacter',
  mentalplus_account_app_version: 'Version de l\'application',
  mentalplus_filtre_ile: 'Île',
  mentalplus_tab_ile_moi: 'Moi',
  mentalplus_tab_ile_amour: 'Amour',
  mentalplus_tab_ile_famille: 'Famille',
  mentalplus_tab_ile_amis: 'Amis',
  mentalplus_tab_ile_ecrans: 'Écran',
  mentalplus_tab_ile_loisirs: 'Loisirs',
  mentalplus_video_filtres: 'Filtres',
  mentalplus_video_enregistrees: 'Enregistrées',
  mentalplus_videos_enregistrees: 'Vidéos enregistrées',
  mentalplus_video_rechercher:  'Rechercher',
  mentalplus_help_signes: 'Signes',
  mentalplus_help_solutions: 'Boosts',
  mentalplus_help_jecris: 'J\'écris',
  mentalplus_help_jecris_question: 'Qu\'est-ce que j\'ai envie d\'écrire ?',
  mentalplus_help_jecris_ajouter: 'Ajouter une note',
  mentalplus_journal_title: 'Mon journal',
  mentalplus_help_num_soutiens: 'J\'en parle',
  mentalplus_help_signes_question: 'Quels sont les signes qui me font prendre conscience que je commence à aller mal ?',
  mentalplus_help_solutions_question: 'Quelles solutions peuvent m’aider à aller mieux ?',
  mentalplus_help_num_epingle: 'Numéro épinglé',
  mentalplus_help_num_epingle_choix: 'Choisir le numéro à épingler',
  mentalplus_help_num_valider: 'Valider ce numéro',
  mentalplus_help_num_gerer:  'Gérer mes numéros d’urgence',
  mentalplus_help_num_gerer_proches:  'Gérer mes numéros de proches',
  mentalplus_help_num_enregistrer: 'Enregistrer',
  mentalplus_help_solutions_ajouter: 'Ajouter une solution',
  mentalplus_help_ajouter: 'Ajouter',
  mentalplus_help_signes_ajouter: 'Ajouter un signe',
  mentalplus_help_num_proches_ajouter: 'Ajouter un proche',
  mentalplus_help_num_proches_nom: 'Nom du proche (ex : Papa)',
  mentalplus_help_num_proches_nom_numero: 'Numéro de téléphone',
  mentalplus_help_num_urgences: 'Numéros d’urgence',
  mentalplus_help_num_utiles: 'Numéros utiles',
  mentalplus_help_num_proches: 'Proches',
  mentalplus_help_num_confiance: 'Personnes de confiance',
  mentalplus_help_num_urgence_single: 'Numéro d\'urgence',
  mentalplus_video_retour: 'Retour',
  mentalplus_video_description: 'Description',
  mentalplus_video_voir_plus: 'voir plus',
  mentalplus_video_description_empty: 'Aucune description pour cette vidéo.',
  mentalplus_video_tout_voir: 'Tout voir',
  mentalplus_video_renitialiser: 'Rénitialiser',
  mentalplus_filtre_categories: 'Catégories',
  mentalplus_filtre_categories_explications: 'Explications',
  mentalplus_filtre_categories_solutions: 'Solutions',
  mentalplus_filtre_realisee: 'Réalisée par',
  mentalplus_filtre_realisee_professionnels: 'Professionnels',
  mentalplus_filtre_realisee_communaute: 'Communauté',
  mentalplus_filtre_realisee_2: 'Réalisée pour',
  mentalplus_filtre_realisee_collegiens: 'Collégiens',
  mentalplus_filtre_realisee_lyceens: 'Lycéens',
  mentalplus_filtre_realisee_etudiants: 'Étudiants',
  mentalplus_filtre_realisee_jeunes_actifs: 'Jeunes actifs',
  mentalplus_filtre_realisee_sans_activite: 'Sans activité',
  mentalplus_filtre_trier: 'Trier par',
  mentalplus_filtre_trier_popularite: 'Popularité',
  mentalplus_filtre_trier_recent: 'Récent',
  mentalplus_filtre_trier_ancien: 'Ancien',
  mentalplus_menu_profile: 'Profil',
  mentalplus_menu_island_settings: 'Paramètres de l’île',
  mentalplus_menu_share: 'Partager {{appName}}',
  menu_share: 'Partager',
  mentalplus_menu_conatct: 'Nous Contacter',
  mentalplus_menu_objet: 'Objet',
  mentalplus_menu_objet_champ: 'Selectionnez un objet',
  mentalplus_menu_equipe: 'Qui sommes-nous ?',
  mentalplus_menu_signaler_un_bug: 'Signaler un bug',
  mentalplus_menu_contacter_l_equipe: 'Contacter l’équipe',
  mentalplus_menu_autre: 'Autre',
  mentalplus_menu_que_faire: 'Que faire ?',
  mentalplus_menu_Son: 'Son',
  mentalplus_video_recherche: 'Aucune vidéo ne correspond à ces filtres.',
  mentalplus_ile_moi_quizz: 'Quiz anxiété dépression',
  mentalplus_video_enregistree: 'Aucune vidéo enregistrée pour le moment.',
};
